module.exports = __webpack_public_path__ + "img/0134.4b5885c0.png";